<template>
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Activity type</th>
          <th>Time</th>
          <th>Up time</th>
          <th>Down time</th>
          <th>Number of cycles</th>
        </tr>
      </thead>
      <transition-group tag="tbody" name="fade">
        <tr v-for="item in entry" :key="item.id">
          <td>{{ item.data.activityType }}</td>
          <td>{{ item.data.pacingTime }}</td>
          <td>{{ item.data.upTime }}</td>
          <td>{{ item.data.downTime }}</td>
          <td>{{ item.data.cycles }}</td>
        </tr>
      </transition-group>
    </table>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "Table",
  props: ["entry"]
};
</script>
